module.exports = __webpack_public_path__ + "img/bell.5c41b550.svg";